<template>
  <button
    v-on:click.stop="toggleAccordion()"
    class="pt-2 px-10 border-b border-neutral-200"
  >
    <div class="flex flex-row justify-center items-center gap-4">
      <slot name="title"></slot>
      <span
        class="w-2 h-2 border-r-2 border-b-2 border-neutral-500 rotate-[45deg] transform duration-200 self-center"
        :class="{ 'rotate-[225deg]': isOpen }"
      ></span>
    </div>
  </button>
  <div v-show="isOpen" class="flex flex-row gap-4 flex-1">
    <slot name="content"></slot>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

const isOpen = ref(true);

function toggleAccordion() {
  isOpen.value = !isOpen.value;
}
</script>
